<nz-page-header class="site-page-header" (nzBack)="onBack()" nzBackIcon>
  <nz-breadcrumb nz-page-header-breadcrumb>
    <nz-breadcrumb-item>
      <i nz-icon nzType="home"></i>
    </nz-breadcrumb-item>

    <nz-breadcrumb-item>
      <i nz-icon nzType="appstore"></i>
      Funcionalidades
    </nz-breadcrumb-item>

    <nz-breadcrumb-item>
      <i nz-icon nzType="star"></i>
      Avisos do sistema
    </nz-breadcrumb-item>

    <nz-breadcrumb-item>
      <i nz-icon nzType="plus"></i>
      {{ systemBroadcast ? 'Editar' : 'Criar' }} aviso do sistema
    </nz-breadcrumb-item>
  </nz-breadcrumb>

  <nz-page-header-title>{{ systemBroadcast ? 'Editar' : 'Criar' }} aviso do sistema</nz-page-header-title>

  <nz-page-header-extra>
    <button nz-button nzType="default" [routerLink]="systemBroadcastId ? '../..' : '..'" [disabled]="submitFormStatus === 'LOADING'">
      <i nz-icon nzType="close"></i>
      Cancelar
    </button>

    <button nz-button nzType="primary" (click)="handleSubmit()" [disabled]="submitFormStatus === 'LOADING'">
      <ng-container *ngIf="submitFormStatus !== 'LOADING'">
        <i nz-icon nzType="check"></i>
        Salvar
      </ng-container>

      <ng-container *ngIf="submitFormStatus === 'LOADING'">
        <i nz-icon nzType="reload" [nzSpin]="true"></i>
        Salvando...
      </ng-container>
    </button>
  </nz-page-header-extra>
</nz-page-header>

<nz-card class="p-4" *ngIf="fetchStatus === 'LOADING'">
  <nz-spin nzTip="Carregando destaques..."></nz-spin>
</nz-card>

<nz-card class="p-4" *ngIf="fetchStatus === 'ERROR'">
  <div style="text-align: center">
    <h2 nz-typography nzType="danger">Erro ao carregar os dados</h2>
    <h4 nz-typography>Ocorreu um erro ao carregar os dados. Tente novamente, por favor.</h4>
    <button nz-button nzType="primary" (click)="fetch()">Tentar novamente</button>
  </div>
</nz-card>

<form nz-form [formGroup]="systemBroadcastForm" *ngIf="fetchStatus === 'SUCCESS'">
  <div nz-row class="p-3">
    <main nz-col nzSpan="24">
      <nz-form-item>
        <nz-form-label [nzSpan]="24" style="font-weight: bold">Título:</nz-form-label>
        <nz-form-control
          nzHasFeedback
          [nzSpan]="24"
          [nzValidateStatus]="title.touched && title.invalid ? 'error' : ''"
          nzErrorTip="Título é obrigatório">
          <input nz-input formControlName="title" placeholder="Ex.: Informativo do mês" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" style="font-weight: bold">Mensagem:</nz-form-label>
        <nz-form-control
          nzHasFeedback
          [nzSpan]="24"
          [nzValidateStatus]="htmlMessage.touched && htmlMessage.invalid ? 'error' : ''"
          nzErrorTip="Mensagem é obrigatória">
          <app-hugerte-editor #editor [config]="hugerteBaseConfig" formControlName="htmlMessage"></app-hugerte-editor>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label
          nzTooltipTitle="Caso selecione os modos que utilizem PUSH, enviar 1 whitelabel por vez."
          [nzSpan]="24"
          style="font-weight: bold">
          Selecionar canal do aviso:
        </nz-form-label>
        <nz-form-control>
          <nz-radio-group formControlName="notificationChannel" id="notificationChannel">
            <label *ngFor="let channel of notificationChannels" nz-radio [nzValue]="channel">
              {{ notificationChannelLabelMap[channel] }}
            </label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>

      <nz-card class="mt-3" *ngIf="isPushChannel" nzTitle="Pré-visualização do Push">
        <app-push-preview [title]="title.value" [message]="htmlMessage.value" [logo]="'assets/img/logo.png'"></app-push-preview>
      </nz-card>

      <nz-form-item>
        <nz-form-label
          nzTooltipTitle="Para adicionar uma rota dentro do próprio sistema use sempre a url econdos como base, exemplo: https://app.econdos.com.br/maintenance/tickets "
          [nzSpan]="24"
          style="font-weight: bold">
          Link:
        </nz-form-label>
        <nz-form-control nzHasFeedback [nzSpan]="24" [nzValidateStatus]="link.touched && link.invalid ? 'error' : ''">
          <input nz-input formControlName="link" placeholder="Ex.: https://app.econdos.com.br/maintenance/tickets" />
        </nz-form-control>
      </nz-form-item>

      <ng-container *ngIf="showLinkFields">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" style="font-weight: bold">Texto do botão:</nz-form-label>
          <nz-form-control nzHasFeedback [nzSpan]="24" [nzValidateStatus]="linkButtonName.touched && linkButtonName.invalid ? 'error' : ''">
            <input nz-input formControlName="linkButtonName" placeholder="Ex.: Saiba mais" />
          </nz-form-control>
        </nz-form-item>
      </ng-container>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" style="font-weight: bold">White label(s):</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select
            formControlName="whiteLabels"
            [nzPlaceHolder]="'Selecione um ou mais whiteLabels'"
            [nzMode]="'multiple'"
            (ngModelChange)="selectAll($event, 'whiteLabels')">
            <nz-option [nzValue]="'ALL'" [nzLabel]="'Todos'"></nz-option>
            <nz-option
              *ngFor="let option of systemWhiteLabels"
              [nzValue]="option._id"
              [nzLabel]="option.companyName || option.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label [nzSpan]="24" style="font-weight: bold">Tipo(s) de usuário(s):</nz-form-label>
        <nz-form-control nzHasFeedback [nzSpan]="24" [nzValidateStatus]="userTypes.touched && userTypes.invalid ? 'error' : ''">
          <nz-select
            formControlName="userTypes"
            [nzPlaceHolder]="'Selecione um ou mais tipos de usuários'"
            [nzMode]="'multiple'"
            (ngModelChange)="selectAll($event, 'userTypes')">
            <nz-option [nzValue]="'ALL'" [nzLabel]="'Todos'"></nz-option>
            <nz-option *ngFor="let option of userTypesLabel | keyvalue" [nzValue]="option.key" [nzLabel]="option.value"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control nzHasFeedback [nzSpan]="24" [nzValidateStatus]="condoTypes.touched && condoTypes.invalid ? 'error' : ''">
          <nz-form-label [nzSpan]="24" style="font-weight: bold">Tipo(s) de condomínio(s):</nz-form-label>
          <nz-select
            formControlName="condoTypes"
            [nzPlaceHolder]="'Selecione um ou mais tipos de condomínios'"
            [nzMode]="'multiple'"
            (ngModelChange)="selectAll($event, 'condoTypes')">
            <nz-option [nzValue]="'ALL'" [nzLabel]="'Todos'"></nz-option>
            <nz-option *ngFor="let option of condoTypesLabel | keyvalue" [nzValue]="option.key" [nzLabel]="option.value"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item *ngIf="condoTypes.value.length > 0">
        <nz-form-label [nzSpan]="24" style="font-weight: bold" nzFor="condos">Aparecer em:</nz-form-label>
        <nz-form-control [nzSpan]="24">
          <nz-select
            formControlName="condos"
            id="condos"
            nzMode="multiple"
            nzPlaceHolder="Selecione os condomínios"
            (ngModelChange)="selectAll($event, 'condos')">
            <nz-option [nzValue]="'ALL'" [nzLabel]="'Todos'"></nz-option>
            <nz-option *ngFor="let condo of systemCondos" [nzLabel]="condo.name" [nzValue]="condo._id"></nz-option>
          </nz-select>
          <small>
            Selecione os condomínios que o anúncio irá aparecer, em caso de nenhum selecionado, aparecerá em todos os condomínios.
          </small>
        </nz-form-control>
      </nz-form-item>

      <div nz-row [nzGutter]="24">
        <div nz-col [nzSpan]="6">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" style="font-weight: bold">Data inicial:</nz-form-label>
            <nz-form-control
              nzHasFeedback
              [nzSpan]="24"
              [nzValidateStatus]="startDate.touched && startDate.invalid ? 'error' : ''"
              nzErrorTip="Data inicial obrigatória">
              <nz-date-picker
                nzLocale=""
                nzFormat="dd/MM/yyyy - HH:mm"
                formControlName="startDate"
                style="width: 100%"
                id="startDate"
                [nzShowTime]="{
                  nzFormat: 'HH:mm',
                  nzHourStep: 1,
                  nzMinuteStep: 10,
                  nzDefaultOpenValue: defaultStartTime
                }"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>

        <div nz-col [nzSpan]="6">
          <nz-form-item>
            <nz-form-label [nzSpan]="24" style="font-weight: bold">Data final:</nz-form-label>
            <nz-form-control
              nzHasFeedback
              [nzSpan]="24"
              [nzValidateStatus]="endDate.touched && endDate.invalid ? 'error' : ''"
              nzErrorTip="Data final precisa ser maior que a data inicial">
              <nz-date-picker
                nzFormat="dd/MM/yyyy - HH:mm"
                formControlName="endDate"
                id="endDate"
                style="width: 100%"
                [nzShowTime]="{ nzFormat: 'HH:mm', nzHourStep: 1, nzMinuteStep: 10, nzDefaultOpenValue: defaultEndTime }"></nz-date-picker>
            </nz-form-control>
          </nz-form-item>
        </div>
      </div>
    </main>
  </div>
</form>
